var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.4993 30.3333V64.1666C64.4993 66.744 62.41 68.8333 59.8327 68.8333H24.8327C24.8327 68.8333 20.166 68.8333 20.166 64.1666V19.8333C20.166 17.256 22.2554 15.1666 24.8327 15.1666H49.3327V25.6666C49.3327 28.244 51.422 30.3333 53.9993 30.3333H64.4993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5007 30.3333H54.0007C51.4233 30.3333 49.334 28.244 49.334 25.6666V15.1666L64.5007 30.3333Z",
    fill: "#E3EDC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3238 29.5073C65.4316 29.6153 65.5172 29.7433 65.5758 29.8842C65.6359 30.0263 65.6668 30.179 65.6668 30.3333V64.1667C65.6629 67.3867 63.0535 69.9961 59.8335 70H24.8335C23.269 70.0593 21.7505 69.4637 20.6435 68.3567C19.5364 67.2496 18.9409 65.7312 19.0001 64.1667V19.8333C19.004 16.6133 21.6134 14.0039 24.8335 14H49.3335C49.6423 14.0001 49.9385 14.1226 50.1571 14.3407L65.3238 29.5073ZM24.8393 67.6667H59.8335C61.7665 67.6667 63.3335 66.0997 63.3335 64.1667V31.5H54.0001C50.7801 31.4961 48.1707 28.8867 48.1668 25.6667V22.1667C48.1668 21.5223 48.6891 21 49.3335 21C49.9778 21 50.5001 21.5223 50.5001 22.1667V25.6667C50.5001 27.5997 52.0671 29.1667 54.0001 29.1667H61.6838L48.8505 16.3333H24.8335C22.9005 16.3333 21.3335 17.9003 21.3335 19.8333V64.1667C21.2834 65.1104 21.6368 66.031 22.3056 66.6987C22.9745 67.3664 23.8956 67.7183 24.8393 67.6667Z",
    fill: "#274642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9177 38.8972L31.5527 54.4543V55.7601L32.338 57H50.4708L52.4488 56.2521V54.8373L51.7578 53.3231L43.498 38.8972H40.9177Z",
    fill: "#E3EDC3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2908 39.86L31.8208 54C31.4654 54.6154 31.4633 55.3731 31.8152 55.9905C32.1671 56.6079 32.8202 56.9921 33.5308 57H50.4708C51.1813 56.9921 51.8344 56.6079 52.1863 55.9905C52.5382 55.3731 52.5361 54.6154 52.1808 54L43.7108 39.86C43.3482 39.2622 42.6998 38.8972 42.0008 38.8972C41.3017 38.8972 40.6533 39.2622 40.2908 39.86Z",
    stroke: "#274642",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45V49",
    stroke: "#274642",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0009 53H42.0109",
    stroke: "#274642",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotices);
export default __webpack_public_path__ + "static/media/notices.7f4cf3386f7968f03878d7862833fdcd.svg";
export { ForwardRef as ReactComponent };